export default {
    namespaced: true,
    state: {
        items: undefined
    },
    mutations: {
        items(state, items) {
            state.items = items
        }
    },
    actions: {
        async init({state, commit, dispatch, rootState}, refresh) {
            if (state.items !== undefined && !refresh) return
            
            commit('items', [])
            
            const pageSections = (
                await dispatch('request/get', {url: 'api/page-section'}, {root: true})
            ).data.data
            
            for (let i = 0; i < pageSections.length; i++) {
                const pageSection = pageSections[i]
                
                const template = rootState.templates.items.find(o => o.id === pageSection.sectionTemplateId)
                
                let areaKey = 0
                const areas = []
                const matches = template.templateHtml.matchAll(/\{\{ area }}/g)
                for (const match of matches) {
                    areas.push({
                        value: 'area_' + pageSection.id + '_' + areaKey,
                        text: 'Area ' + (areaKey + 1)
                    })
                    
                    areaKey++
                }
                
                pageSection.areas = areas
            }
            
            commit('items', pageSections)
        }
    }
}